import { Routes } from '@angular/router';
import { ListeValeursParametrablesComponent } from './pages/liste-valeurs-parametrables/liste-valeurs-parametrables.component';
import { CLONES_ROUTES, CLONES_ROUTES_DATA } from './pages/clones/clones.routes';
import { VARIETES_ROUTES, VARIETES_ROUTES_DATA } from './pages/varietes/varietes.routes';
import { GROUPES_VARIETAUX_ROUTES, GROUPES_VARIETAUX_ROUTES_DATA } from './pages/groupes-varietaux/groupes-varietaux.routes';
import { FONCTIONS_ROUTES, FONCTIONS_ROUTES_DATA } from './pages/fonctions/fonctions.routes';
import { TERROIRS_ROUTES, TERROIRS_ROUTES_DATA } from './pages/terroirs/terroirs.routes';
import { STRUCTURES_ROUTES, STRUCTURES_ROUTES_DATA } from './pages/structures/structures.routes';
import { PROTECTIONS_GEL_ROUTES, PROTECTIONS_GEL_ROUTES_DATA } from './pages/protections-gel/protections-gel.routes';
import { PROTECTIONS_GRELE_ROUTES, PROTECTIONS_GRELE_ROUTES_DATA } from './pages/protections-grele/protections-grele.routes';
import { PORTES_GREFFES_ROUTES, PORTES_GREFFES_ROUTES_DATA } from './pages/portes-greffes/portes-greffes.routes';
import { CULTURES_BIO_ROUTES, CULTURES_BIO_ROUTES_DATA } from './pages/cultures-bio/cultures-bio.routes';
import { FORMES_ROUTES, FORMES_ROUTES_DATA } from './pages/formes/formes.routes';
import { SYSTEMES_IRRIGATIONS_ROUTES, SYSTEMES_IRRIGATIONS_ROUTES_DATA } from './pages/systemes-irrigations/systemes-irrigations.routes';
import { SITUATIONS_ROUTES, SITUATIONS_ROUTES_DATA } from './pages/situations/situations.routes';
import { GROUPES_DIFFUSION_ROUTES, GROUPES_DIFFUSION_ROUTES_DATA } from './pages/groupes-diffusion/groupes-diffusion.routes';
import { TYPE_INTERACTIONS_ROUTES, TYPE_INTERACTIONS_ROUTES_DATA } from './pages/type-interactions/type-interactions.routes';

export const VALEURS_PARAM_ROUTE_DATA = {
    role: 'ORGANISME',
    domaines: ['ANPP'],
    menu: {
        libelle: 'menu.administration-listes',
        icon: 'key'
    }
};

export const VALEURS_PARAM_ROUTES: Routes = [
    { path: '', component: ListeValeursParametrablesComponent },
    { path: 'varietes', data: VARIETES_ROUTES_DATA, children: VARIETES_ROUTES },
    { path: 'groupes', data: GROUPES_VARIETAUX_ROUTES_DATA, children: GROUPES_VARIETAUX_ROUTES },
    { path: 'clones', data: CLONES_ROUTES_DATA, children: CLONES_ROUTES },
    { path: 'fonctions', data: FONCTIONS_ROUTES_DATA, children: FONCTIONS_ROUTES },
    { path: 'terroirs', data: TERROIRS_ROUTES_DATA, children: TERROIRS_ROUTES },
    { path: 'structures', data: STRUCTURES_ROUTES_DATA, children: STRUCTURES_ROUTES },
    { path: 'protectionGel', data: PROTECTIONS_GEL_ROUTES_DATA, children: PROTECTIONS_GEL_ROUTES },
    { path: 'protectionGrele', data: PROTECTIONS_GRELE_ROUTES_DATA, children: PROTECTIONS_GRELE_ROUTES },
    { path: 'portegreffes', data: PORTES_GREFFES_ROUTES_DATA, children: PORTES_GREFFES_ROUTES },
    { path: 'cultureBio', data: CULTURES_BIO_ROUTES_DATA, children: CULTURES_BIO_ROUTES },
    { path: 'formes', data: FORMES_ROUTES_DATA, children: FORMES_ROUTES },
    { path: 'irrigations', data: SYSTEMES_IRRIGATIONS_ROUTES_DATA, children: SYSTEMES_IRRIGATIONS_ROUTES },
    { path: 'situations', data: SITUATIONS_ROUTES_DATA, children: SITUATIONS_ROUTES },
    { path: 'groupediffusion', data: GROUPES_DIFFUSION_ROUTES_DATA, children: GROUPES_DIFFUSION_ROUTES },
    { path: 'typeInteraction', data: TYPE_INTERACTIONS_ROUTES_DATA, children: TYPE_INTERACTIONS_ROUTES }
];
